import { render, staticRenderFns } from "./CompanyOverview.vue?vue&type=template&id=00622ab1&scoped=true&"
import script from "./CompanyOverview.vue?vue&type=script&lang=js&"
export * from "./CompanyOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00622ab1",
  null
  
)

export default component.exports